import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=007d400a&scoped=true&"
import script from "./backTop.vue?vue&type=script&lang=js&"
export * from "./backTop.vue?vue&type=script&lang=js&"
import style0 from "./backTop.vue?vue&type=style&index=0&id=007d400a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d400a",
  null
  
)

export default component.exports